<span [innerHTML]="formatear()"></span>